import React, { useState } from "react";
import styled from "styled-components";
import Button from "../Button";
import { Colors } from "../../config/Constants";
import dayjs from "dayjs";
import DatePickerInput from "../Datepicker";
import { toast } from "react-toastify";
import { ToastMessage } from "../ToastMessage";
import { useLoadContext } from "../../contexts/LoadContext";
import { downloadDisputeReport } from "../../services/disputeService";

type ReportDownloadProp = {
  setOpenOrClose: (a: boolean) => void;
};

const ReportDownload = ({ setOpenOrClose }: ReportDownloadProp) => {
  const [fromDate, setFromDate] = useState<Date | null | any>();
  const [toDate, setToDate] = useState<Date | null | any>();
  let today = new Date();
  // let oneMonthDays = dayjs(fromDate).add(30, "days").toDate();
  const { setLoader } = useLoadContext();

  //   const aheadOneMonth = () => {
  //     return dayjs().isBefore(dayjs(oneMonthDays)) ? today : oneMonthDays;
  //   };

  const handleDownloadClick = async () => {
    let sendFromDate = dayjs(fromDate).format("YYYY-MM-DD");
    let sendToDate = dayjs(toDate).format("YYYY-MM-DD");
    setLoader(true);
    try {
      const response = await downloadDisputeReport(sendFromDate, sendToDate);
      const outputFilename = `transactions.xlsx`;
      const url = URL.createObjectURL(
        new Blob([response.data], {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", outputFilename);
      document.body.appendChild(link);
      link.click();
    } catch (error: any) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoader(false);
  };

  return (
    <StyledReportDownload>
      <ReportDownloadHeader>
        <HeaderTitle>Download Report</HeaderTitle>
        <Close
          src={require("../../assets/images/ei_close.png")}
          alt="close"
          onClick={() => setOpenOrClose(false)}
        />
      </ReportDownloadHeader>
      <ReportDownloadBody>
        <Label>From Date</Label>

        <DatePickerInput
          //@ts-ignore
          value={fromDate}
          maxDate={today}
          onChange={(e) => {
            setFromDate(e);
            setToDate(null);
          }}
        />
        <Label>To Date</Label>
        <DatePickerInput
        width="16.125rem"
          disabled={fromDate ? false : true}
          //@ts-ignore
          value={toDate}
          minDate={dayjs(fromDate).toDate()}
          maxDate={today}
          onChange={setToDate}
        />
        <ButtonWrapper>
          <Button
            label="Download"
            variant="filled"
            color={Colors.solidRed}
            disabled={fromDate && toDate ? false : true}
            size="medium"
            isRounded={true}
            onClick={() => {
              handleDownloadClick();
              setOpenOrClose(false);
            }}
          />
        </ButtonWrapper>
      </ReportDownloadBody>
    </StyledReportDownload>
  );
};

export default ReportDownload;

const StyledReportDownload = styled.div`
  padding: 1.625rem 2.2rem 1.8rem 2.25rem;
`;
const ReportDownloadHeader = styled.div`
  display: flex;
  justify-content: center;
`;
const HeaderTitle = styled.div`
  font-family: "Poppins-Medium";
  font-size: 1rem;
  color: ${Colors.mineShaft};
`;
const Close = styled.img`
  transform: translate(4.375rem, -0.25rem);
  cursor: pointer;
`;
const ReportDownloadBody = styled.div`
  display: flex;
  flex-direction: column;
`;
const ButtonWrapper = styled.div`
  margin-top: 1.5rem;
`;
const Label = styled.label`
  font-family: "Poppins-Medium";
  font-size: 0.8rem;
  color: ${Colors.comet};
  margin-top: 1.56rem;
  margin-bottom: 0.625rem;
`;
